export default {
  mutations: {
    SET_I18N_LOCAL_MESSAGE: 'SET_I18N_LOCAL_MESSAGE',
    SET_HOST_CONFIGURATION: 'SET_HOST_CONFIGURATION',
  },
  getters: {
    GET_HOST_CONFIGURATION: 'GET_HOST_CONFIGURATION',
  },
  actions: {
    HOST_CONFIGURATION: 'HOST_CONFIGURATION',
  },
};
